import PropTypes from 'prop-types';

// @mui
import { Box, Card, Link, Typography, Stack } from '@mui/material';
import { styled } from '@mui/material/styles';
// utils
// components
import Label from '../../../components/label';
import imgDefault from '../../../image/default/noimageavailable.png';
import Switch from 'src/components/Switch/Switch';
import { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import ConfirmLockModal from 'src/components/modal/ConfirmLockModal';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';
import ButtonAction from 'src/components/Button.js/SaveButton';
import Iconify from 'src/components/iconify/Iconify';
import DeviceDetail from 'src/components/DrawerSidebar/DeviceDetail';
// ----------------------------------------------------------------------

const StyledProductImg = styled('img')({
    top: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    position: 'absolute',
    padding: '10px',
    borderRadius: '10px',
});

// ----------------------------------------------------------------------

CellCard.propTypes = {
    product: PropTypes.object,
};

export default function CellCard({
    importWarehouse = false,
    idPermission,

    dataActionRef,
    navigate,
    setData,
    product,
    functEdit,
    functDelete,
    getData,
    typeCabinet,
    screenPermissions,
}) {
    const [visibleLock, setVisibleLock] = useState(false);
    const lockRefFlags = useRef(false);
    const [visible, setVisible] = useState(false);
    const { t } = useTranslation();
    const [lockFlags, setLockFlags] = useState(false);

    const handleLock = () => {
        if (!product.id || !idPermission) return toast.error(t('error.system_error'));
        if (lockRefFlags.current) {
            return;
        }
        setLockFlags(true);
        lockRefFlags.current = true;
        const InVal = [
            +idPermission,
            product.cabinet_id,
            product.drawer_id,
            product.id,
            product.block_status === '1' ? '0' : '1',
        ];
        sendRequest(serviceList.lockbox, InVal, lockResult, true, timeOutFunctLock, 40000);
    };

    const lockResult = (reqInfoMap, message) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            setVisibleLock(false);
            return;
        } else {
            toast.success(message['proc_message']);
            setVisibleLock(false);
            getData();
        }
    };

    const timeOutFunctLock = (reqInfo) => {
        setLockFlags(false);
        lockRefFlags.current = false;
        toast.error(t('error.time_out'));
    };
    return (
        <Card style={{ cursor: 'pointer', width: '200px', minWidth: typeCabinet === 'round' ? '235px' : '200px' }}>
            <DeviceDetail device={product} open={visible} setOpen={setVisible} />
            <ConfirmLockModal visible={visibleLock} setVisible={setVisibleLock} handleSave={handleLock} />
            <Box sx={{ pt: '100%', position: 'relative', borderRadius: '10px' }}>
                {importWarehouse ? (
                    <Label
                        variant="filled"
                        color={product?.block_status === '0' ? 'error' : 'primary'}
                        sx={{
                            zIndex: 9,
                            top: 16,
                            right: 16,

                            position: 'absolute',
                            textTransform: 'uppercase',
                            padding: '5px 10px',
                        }}
                    >
                        {product?.block_status === '0' ? (
                            <Iconify icon="material-symbols:lock" />
                        ) : (
                            <Iconify icon="material-symbols:lock-open-right-rounded" />
                        )}
                    </Label>
                ) : (
                    ''
                )}{' '}
                {product.check_inv_status === '0' ? (
                    <Label
                        variant="filled"
                        color={'error'}
                        sx={{
                            zIndex: 9,
                            bottom: 10,
                            left: 16,

                            position: 'absolute',
                            textTransform: 'uppercase',
                            padding: '5px 10px',
                        }}
                    >
                        {t('system_statistical')}
                    </Label>
                ) : (
                    ''
                )}{' '}
                {product?.device_nm && (
                    <>
                        {product?.min_no > product?.qty || product?.max_no <= product?.qty ? (
                            <Label
                                variant="filled"
                                color={'warning'}
                                sx={{
                                    zIndex: 9,
                                    bottom: -10,
                                    left: 16,

                                    position: 'absolute',
                                    textTransform: 'uppercase',
                                    padding: '5px 10px',
                                }}
                            >
                                {product?.min_no > product?.qty ? (
                                    <>
                                        {' '}
                                        <Iconify icon="material-symbols:warning-outline-rounded" />{' '}
                                        {t('warning_import')}
                                    </>
                                ) : (
                                    <>
                                        {' '}
                                        <Iconify icon="material-symbols:warning-outline-rounded" />{' '}
                                        {t('warning_export')}
                                    </>
                                )}
                            </Label>
                        ) : (
                            ''
                        )}
                    </>
                )}
                {product?.img_device || product?.pic_device ? (
                    <StyledProductImg
                        onClick={() => {
                            navigate();
                            setVisible(true);
                        }}
                        alt={glb_sv.convertMultipleLanguages(product?.device_nm)}
                        src={
                            product?.img_device
                                ? `${glb_sv.urlGetProductImage(product?.img_device)}`
                                : `${glb_sv.urlGetProductImage(product?.pic_device)}`
                        }
                    />
                ) : (
                    <StyledProductImg
                        onClick={navigate}
                        alt={glb_sv.convertMultipleLanguages(product?.device_nm)}
                        src={imgDefault}
                    />
                )}
            </Box>
            <Stack spacing={1} sx={{ p: 2 }}>
                <Link
                    color="primary"
                    underline="hover"
                    onClick={() => {
                        navigate();
                        setVisible(true);
                    }}
                    style={{ display: 'flex', fontStyle: 'italic', justifyContent: 'flex-start', alignItems: 'center' }}
                >
                    <Typography variant="subtitle1" noWrap justifyContent={'center'} alignItems={'center'}>
                        {product?.device_cd ? glb_sv.convertMultipleLanguages(product.device_cd) : t('not_device')}
                    </Typography>
                </Link>

                <Stack direction="row" alignItems="center" justifyContent="space-between">
                    {/* <ColorPreview colors={colors} /> */}
                    <Typography variant="subtitle1">
                        <Typography
                            component="span"
                            variant="body1"
                            sx={{
                                color: 'text.disabled',
                            }}
                        >
                            {t('quantity_category')}:
                        </Typography>
                        &nbsp;
                        {product?.qty}
                    </Typography>{' '}
                    {typeCabinet === 'square' ? (
                        <Typography variant="subtitle1">
                            <Typography
                                component="span"
                                variant="body1"
                                sx={{
                                    fontSize: '14px',
                                    color: 'text.disabled',
                                }}
                            >
                                {t('cell')}:
                            </Typography>
                            &nbsp;{`[ ${product?.cell_lc?.row} : ${product?.cell_lc?.column} ]`}
                        </Typography>
                    ) : (
                        <Typography variant="subtitle1">
                            <Typography
                                component="span"
                                variant="body1"
                                sx={{
                                    fontSize: '14px',
                                    color: 'text.disabled',
                                }}
                            >
                                {t('ordinal_number')}:
                            </Typography>
                            &nbsp; {product?.cell_lc?.column}
                        </Typography>
                    )}
                </Stack>
                {importWarehouse ? (
                    <Stack direction="row" alignItems="center" justifyContent="center">
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                                // '& > *': {
                                //     m: 1,
                                // },
                            }}
                        >
                            {screenPermissions?.import_permission === '1' && (
                                <ButtonAction
                                    onClick={() => {
                                        dataActionRef && (dataActionRef = product);
                                        setData(product);
                                        functEdit(product);
                                    }}
                                    title={t('import')}
                                    disabled={
                                        product?.block_status === '1' && product.check_inv_status === '1' ? false : true
                                    }
                                    type="import"
                                />
                            )}
                            {screenPermissions?.export_permission === '1' && (
                                <ButtonAction
                                    onClick={() => {
                                        dataActionRef && (dataActionRef = product);
                                        setData(product);
                                        functDelete(product);
                                    }}
                                    disabled={
                                        product?.block_status === '1' &&
                                        product?.device_nm &&
                                        product.check_inv_status === '1'
                                            ? false
                                            : true
                                    }
                                    title={t('export')}
                                    type="export"
                                />
                            )}
                        </Box>
                    </Stack>
                ) : (
                    <Stack direction="row" alignItems="center" justifyContent="center">
                        <Box
                            sx={{
                                display: 'flex',
                                width: '100%',
                                alignItems: 'center',
                                justifyContent: 'space-between',
                            }}
                        >
                            {' '}
                            {screenPermissions?.block_permission === '1' && (
                                <Switch
                                    checked={product?.block_status === '1' ? true : false}
                                    onClick={() => setVisibleLock(true)}
                                />
                            )}
                            {screenPermissions?.update_permission === '1' && product.check_inv_status === '1' ? (
                                <ButtonAction
                                    onClick={() => {
                                        dataActionRef && (dataActionRef = product);
                                        setData(product);
                                        functEdit();
                                    }}
                                    title={t('update')}
                                    type="update"
                                />
                            ) : (
                                ''
                            )}
                        </Box>
                    </Stack>
                )}
            </Stack>
        </Card>
    );
}
